import {datadogRum} from '@datadog/browser-rum';
import * as Sentry from '@sentry/browser'; // eslint-disable-line import/no-namespace

const configureUserMonitoring = (user?: {id: string} | null): void => {
  if (user) {
    Sentry.setUser({id: user.id});
    datadogRum.setUser({id: user.id});
  }
};

export default configureUserMonitoring;
